'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _app = require('../../app/app.constants');

var _app2 = _interopRequireDefault(_app);

var _util = require('../util/util.module');

var _util2 = _interopRequireDefault(_util);

var _angularCookies = require('angular-cookies');

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _interceptor = require('./interceptor.service');

var _router = require('./router.decorator');

var _auth = require('./auth.service');

var _user = require('./user.service');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addInterceptor($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push('authInterceptor');
}

exports.default = _angular2.default.module('parkingFormApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;


// WEBPACK FOOTER //
// ./client/components/auth/auth.module.js